// const baseUrl = 'http://127.0.0.1:11807';
const baseUrl = 'https://api.anythingai.online';
export default baseUrl